<template>
  <div class="posterCategory">
    <el-divider content-position="left">营销海报分类</el-divider>
    <el-row
      ><el-button type="primary" size="mini" @click="handleAddOpen"
        >添加分类</el-button
      ></el-row
    >
    <el-table height="calc(100vh - 266px)" :data="pageData" size="medium" style="width: 100%" border>
      <el-table-column label="id">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="分类名称">
        <template slot-scope="scope">
          {{ scope.row.category_name }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="140">
        <template slot-scope="scope">
          <!-- {{scope.row.created_at}} -->
          <date-formatter :date-value="scope.row.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDel(scope.$index, scope.row.id)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-dialog
      title="添加分类"
      :visible.sync="addVisible"
      width="30%"
      :before-close="handleAddClose"
    >
      <div>
        <el-row>
          <el-input placeholder="请输入分类名" v-model="addCategoryName" clearable>
          </el-input>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="handleAdd">添 加</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑分类"
      :visible.sync="editVisible"
      width="30%"
      :before-close="handleEditClose"
    >
      <div>
        <el-row>
          <el-input placeholder="请输入分类名" v-model="editData.category_name" clearable>
          </el-input>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="handleSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DateFormatter from "common/DateFormatter";
export default {
  name: "MarketPosterCategory",
  components: { DateFormatter },
  data() {
    return {
      category: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      addVisible: false,
      editVisible: false,
      addCategoryName: "",
      oldName: "",
      editData: {
        id: null,
        index: null,
        category_name: "",
      },
    };
  },
  computed: {
    pageData: {
      get: function () {
        return this.category.slice(
          this.pageOption.pageSize * (this.pageOption.currentPage - 1),
          this.pageOption.pageSize * this.pageOption.currentPage
        );
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    posterCategory() {
      this.$axios.get("/api/admin/marketPosterCategories").then((res) => {
        const { data } = res;
        if (data.code === 200) {
          this.category = data.data;
          this.pageOption.total = this.category.length;
        }
      });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
    },
    handleAddOpen() {
      this.addVisible = true;
    },
    handleAddClose() {
      this.addCategoryName = "";
      this.addVisible = false;
    },
    handleAdd() {
      if (!this.addCategoryName.trim()) {
        this.$message.error("请输入分类名称");
        return;
      }
      this.$axios
        .post("/api/admin/marketPosterCategories", {
          category_name: this.addCategoryName,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            this.category.push(data.data);
            this.handleAddClose();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleEdit(index, row) {
      this.editData.id = row.id;
      this.editData.index = index;
      this.editData.category_name = row.category_name;
      this.oldName = row.category_name;
      this.editVisible = true;
    },
    handleEditClose() {
      this.editData.id = null;
      this.editData.index = null;
      this.editData.category_name = "";
      this.oldName = "";
      this.editVisible = false;
    },
    handleSave() {
      if (!this.editData.category_name.trim()) {
        this.$message.error("请输入分类名称");
        return;
      }

      if (this.oldName === this.editData.category_name) {
        this.handleEditClose();
        return;
      }

      this.$axios
        .post("/api/admin/marketPosterCategories/update", {
          id: this.editData.id,
          category_name: this.editData.category_name,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            let index =
              this.pageOption.pageSize * (this.pageOption.currentPage - 1) +
              this.editData.index;
            this.category[index].category_name = this.editData.category_name;
            this.handleEditClose();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleDel(index, id) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDeleteSub(index, id);
        })
        .catch(() => {});
    },
    handleDeleteSub(index, id) {
      this.$axios
        .post("/api/admin/marketPosterCategories/destroy", { id })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            let idx =
              this.pageOption.pageSize * (this.pageOption.currentPage - 1) + index;
            this.category.splice(idx, 1);
            if (index === 0) this.prePage();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    prePage() {
      if (this.pageOption.currentPage === 1) return;
      this.pageOption.currentPage = this.pageOption.currentPage - 1;
    },
  },
  mounted() {
    this.posterCategory();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.el-row
  margin-bottom: .2rem
.posterCategory
  marginLeft()
.page-footer
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
.pagination-style
  padding-top: 25px;
  text-align: right;
</style>



// WEBPACK FOOTER //
// src/pages/market_poster/PosterCategory.vue